module.exports = __webpack_public_path__ + "static/media/delete-red.d857c062.svg";